import { render, staticRenderFns } from "./VoicePatient.vue?vue&type=template&id=1fc52aa2&scoped=true"
import script from "./VoicePatient.vue?vue&type=script&lang=js"
export * from "./VoicePatient.vue?vue&type=script&lang=js"
import style0 from "./VoicePatient.vue?vue&type=style&index=0&id=1fc52aa2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc52aa2",
  null
  
)

export default component.exports